<template>
    <div class="main-body">
        <div class="header">
            入账记录
        </div>
        <div class="out">
            <div class="search2">

                <el-button size="mini" type="primary" @click="noAccountingRecord">待入账</el-button>
                <div style="float:right">
<!--                    <el-select v-model="status" size="mini" placeholder="请选择订单状态" style="width:200px;margin-right:10px">-->
<!--                        <el-option-->
<!--                            v-for="item in statusValue"-->
<!--                            :key="item[0]"-->
<!--                            :label="item[1]"-->
<!--                            :value="item[0]">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                    <Daterange :startTime="startTime" :endTime="endTime" style="width:200px;margin-right:10px" @dataChange='dataChange'></Daterange>
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                </div>

                <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;">
                <el-table-column prop="createTime" :formatter="timefilter" label="时间"></el-table-column>
                <el-table-column prop="price" label="入账金额（元）"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.status==1">未入账</el-tag>
                        <el-tag type="success" v-if="scope.row.status==2">已入账</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleInfo(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Info ref="myInfo" v-show="showModalInfo"  v-on:closeInfo="showModalInfo=false" v-on:getList="getList"></Info>
        <StayInfo ref="myStayInfo" v-show="showModalStayInfo"  v-on:closeStayInfo="showModalStayInfo=false" v-on:getList="getList"></StayInfo>
    </div>
</template>

<script>

    import {timeStr,timefilters,getMonthDay} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Info from "./Info";
    import StayInfo from "./StayInfo";
    import {getStaffCode} from "@/utils/auth";
    import Daterange from "@/components/Daterange";
    export default {
        name: "Role",
        data(){
            return{
                tableLoading:false,
                showModalInfo:false,
                showModalStayInfo:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                type:'',
                startTime:'',
                endTime:'',
                status:1,
                statusValue:[[-1,'全部状态'],[1,'未入账'],[2,'已入账']]
            }
        },
        components:{
            Info,Daterange,StayInfo
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                this.endTime = getMonthDay('e', 0)
                this.startTime = getMonthDay('s', 0)
            },
            timefilter(row,index,column){
                return timefilters(column).slice(0,10)
            },
            handleInfo(row){
                this.showModalInfo=true
                this.$refs.myInfo.init(row);
            },
            noAccountingRecord(){
                this.showModalStayInfo=true
                this.$refs.myStayInfo.init();

            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            dataChange(val){
                this.startTime=val[0]
                this.endTime=val[1]
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AccountingRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        status:this.status,
                        startTime:this.startTime,
                        endTime:this.endTime
                    }
                }).then( (response)=> {
                    this.tableLoading=false
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 1){
                    return "正常";
                }
                if(row.status == 2){
                    return "废弃";
                }
                return "其它";
            },
        }
    }
</script>

<style scoped>

</style>
